import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './assets/scss/material-kit-react.scss?v=1.8.00';
import 'font-awesome/css/font-awesome.min.css';
import ReactGA from "react-ga4";
import CssBaseline from "@mui/material/CssBaseline";
import {
    ThemeProvider,
    createTheme,
    StyledEngineProvider
} from "@mui/material/styles";
import { ensureAnalyticsInitialized } from './utils/analytics';

// GA4 initialization is deferred until analytics consent is granted.
ensureAnalyticsInitialized();
// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

const theme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: "0.8rem"
          }
        }
      }
    }
  });

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
            <CssBaseline />
                <StyledEngineProvider injectFirst>
                    <App />
                </StyledEngineProvider>
            </ThemeProvider>
        </BrowserRouter>
    </Provider>
);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(app);

registerServiceWorker();
